import React from 'react';
import axios from 'axios';
import {withRouter} from "react-router-dom";

class AwardPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {}
        }
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getAward();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getAward();
        }
    }

    getAward() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.awards + "/" + this.props.match.params.id, config)
                .then((response) => {
                    this.setState({
                        values: {
                            ...response.data
                        }
                    });
                }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst odměnu!');
                this.props.history.push('/awards');
                console.log("Axios error: ", error);
            });
        }
    }

    render () {
        let award = this.state.values;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Náhled odměny {award.name}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <h4>Základní údaje</h4>
                        <table className="table table-striped table-responsive">
                            <tbody>
                            <tr>
                                <th>Název:</th>
                                <td>{award.name}</td>
                            </tr>
                            <tr>
                                <th>Cena:</th>
                                <td>{award.moneyValue}</td>
                            </tr>
                            <tr>
                                <th>Popis:</th>
                                <td>{award.description}</td>
                            </tr>
                            <tr>
                                <th>Do soutěže věnoval:</th>
                                <td>{award.donatedBy}</td>
                            </tr>
                            <tr>
                                <th>Použít jako avatara:</th>
                                <td>{award.useAsAvatar ? 'ano' : 'ne'}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-lg-offset-1 col-md-offset-1 col-sm-offset-1">
                        <h4>Obrázek</h4>
                        {award.image && <img className="center-block" src={`${__APIURL__}/${award.image}`} alt="Obrázek speciálu"/>}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AwardPreview);



/** WEBPACK FOOTER **
 ** ./src/containers/Awards/AwardPreview.js
 **/